import type { RefObject } from 'react'
import { useEffect, useState } from 'react'
import { useApi } from '@/contexts/ApiContext'
import { StoreTagMetadata } from '@/types/enums/StoreTypes'

export function handleNavbarScrollingBehavior(
    showSubheader: boolean,
    setShowSubheader: (visible: boolean) => void,
    setHoverButtonShrink: (visible: boolean) => void,
    contentRef: RefObject<HTMLDivElement>,
) {
    let lastScrollY = window.scrollY

    const shouldCollapse = () => {
        const currentScrollY = window.scrollY
        const scrollUp = currentScrollY < lastScrollY
        const scrollDelta = Math.abs(currentScrollY - lastScrollY)
        const contentTop = contentRef.current?.getBoundingClientRect().top || 0

        if ((contentTop <= 30 || currentScrollY > 60) && showSubheader) {
            setShowSubheader(false)
        } else if (currentScrollY === 0 && !showSubheader) {
            setShowSubheader(true)
        } else if (scrollUp && scrollDelta > 30 && !showSubheader) {
            setShowSubheader(true)
        }

        if (currentScrollY > 60) {
            setHoverButtonShrink(true)
        }

        lastScrollY = currentScrollY
    }

    const handleScroll = () => {
        window.requestAnimationFrame(shouldCollapse)
    }

    window.addEventListener('scroll', handleScroll)

    return () => {
        window.removeEventListener('scroll', handleScroll)
    }
}

export function useStoreTagsInfo(categoryName: string | null) {
    const { apiGet } = useApi()
    const [metadata, setMetadata] = useState<StoreTagMetadata | null>(null)

    useEffect(() => {
        if (!categoryName) {
            setMetadata(null)
            return
        }
        apiGet(`/external/category/${encodeURIComponent(categoryName)}/metadata`)
            .then((data) =>
                setMetadata({
                    title: data.title,
                    subtitle: data.subtitle,
                    slug: data.slug,
                    mobileTitle: data.mobileTitle,
                }),
            )
            .catch(() => setMetadata(null))
    }, [categoryName, apiGet])

    return metadata
}
